import React, { memo, useMemo } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { List } from '../material-ui/List';
import { SidebarItem } from './SidebarItem/SidebarItem';
import { ButtonType, sidebarButton } from './constants';
import { useSidebarContent } from './useSidebarContent';
import { useStyles } from './useStyles';

import './Sidebar.scss';

export const SidebarContent = memo(() => {
    const classes = useStyles();

    const { value, canDownloadTaskData, crewType, partitions, handleItemClick } = useSidebarContent();

    const { t: translate } = useTranslation();

    const partitionList = useMemo(
        () => 
            Object.entries(partitions).map(([key, { buttonType, visible }]) => {
                if (!sidebarButton[buttonType] || !visible) {
                    return;
                }

                const { component: Component, icon: Icon, label, activeTask = false, crewLimit } = sidebarButton[buttonType];

                if (!activeTask ||
                    canDownloadTaskData && activeTask && (!crewLimit || crewLimit.includes(crewType))) {

                    return Component ?
                        <Component
                            key={key}
                            value={buttonType}
                            onClick={handleItemClick}
                            selected={value === buttonType} />
                        : <SidebarItem
                            key={key}
                            value={buttonType}
                            onClick={handleItemClick}
                            primary={translate(label)}
                            selected={value === buttonType}
                            textClassName={classes.listItemText}
                            iconClassName={classes.listIcon}
                            className={classnames('sidebar-menu__item', buttonType === ButtonType.SEND_DATA ? classes.simple : null)}
                        >
                            <Icon width="24" height="24" className={classes.icon} />
                        </SidebarItem>;
                }
            }), [value, canDownloadTaskData, crewType, partitions, handleItemClick, translate]
    );

    return (
        <>
            <div className={classes.toolbar} />
            <List className="sidebar-menu">
                {partitionList}
            </List>
        </>
    );
});

SidebarContent.displayName = 'SidebarContent';
